import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {WEBSITE_MODULE} from "../website-module.consts";
import {WebsiteModuleState} from "../models/website-module.state";
import {POPUP_DISPLAY} from "../../../core/models/popup/consts";
import {LocalStorageUtils} from "../../../infrastructure/utils/local-storage.utils";
import {PopupsDisplayManager} from "../../../core/managers/popups-display.manager";
import {UserAgentViewModel} from "../../../core/models/user-agent.view-model";
import {CookieManager} from "../../../core/managers/cookie-manager";

export class WebsiteModuleDidomiAutoDisplayHandler extends ActionHandler {
  state: WebsiteModuleState;
  type = WEBSITE_MODULE.ACTION_TYPES.didomiWidgetAutoDisplayHandler;

  static injectables = [...ActionHandler.injectables, LocalStorageUtils, PopupsDisplayManager, UserAgentViewModel, CookieManager];

  constructor(localStorageUtils: LocalStorageUtils, popupsDisplayManager: PopupsDisplayManager, userAgentViewModel: UserAgentViewModel, cookieManager: CookieManager) {
    super();

    this.localStorageUtils = localStorageUtils;
    this.popupsDisplayManager = popupsDisplayManager;
    this.userAgentViewModel = userAgentViewModel
    this.cookieManager = cookieManager;
  }

  onLoaded() {
    this.action({})
    this.popupsDisplayManager.registerToChange(POPUP_DISPLAY.AUTO_DISPLAY_POPUPS.didomi,
      (params) => this.action(params)
    );
  }

  action(params) {
    const userAlreadySeenDidomiPopup = this.cookieManager.didomiToken;

    if (userAlreadySeenDidomiPopup) {
      this.controller.state.shouldDisplayDidomiPopup = userAlreadySeenDidomiPopup;
    } else {
      const shouldRenderDidomiPopup = (!this.userAgentViewModel.isPrerender && this.appStore.state.shouldSupportConsent && params.display);
      this.popupsDisplayManager.setPopupDisplayStatus(POPUP_DISPLAY.AUTO_DISPLAY_POPUPS.didomi, shouldRenderDidomiPopup)

      this.controller.state.shouldDisplayDidomiPopup = shouldRenderDidomiPopup;
    }
  }
}
